
import { Injectable, Inject } from '@angular/core';
import{BasePolicyAgentDO} from './basePolicyAgent.model';


export class GroupPolicyAgentDO extends BasePolicyAgentDO  {
    
     public  id:number = null;

}